import * as React from "react"

export default function StripeLogo(props) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#635BFF" d="M0 0H48V48H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.451 24.267c0-2.734-1.324-4.892-3.855-4.892-2.543 0-4.08 2.158-4.08 4.87 0 3.216 1.815 4.84 4.421 4.84 1.271 0 2.233-.29 2.959-.695v-2.136c-.726.363-1.56.587-2.617.587-1.036 0-1.955-.363-2.072-1.623h5.223c0-.14.021-.695.021-.951zm-5.276-1.015c0-1.207.737-1.709 1.41-1.709.651 0 1.346.502 1.346 1.71h-2.756zm-6.782-3.877c-1.047 0-1.72.491-2.094.833l-.139-.662h-2.35V32l2.67-.566.011-3.023c.385.278.95.673 1.89.673 1.913 0 3.654-1.538 3.654-4.924-.011-3.097-1.773-4.785-3.642-4.785zm-.641 7.36c-.63 0-1.004-.225-1.26-.503l-.011-3.962c.277-.31.662-.524 1.27-.524.973 0 1.646 1.09 1.646 2.489 0 1.431-.663 2.5-1.645 2.5zm-7.616-7.99l2.681-.577V16l-2.68.566v2.179zm0 .812h2.681v9.346h-2.68v-9.346zm-2.873.79l-.17-.79h-2.308v9.346h2.67v-6.334c.63-.823 1.699-.673 2.03-.556v-2.456c-.342-.128-1.592-.363-2.222.79zm-5.34-3.108l-2.607.555-.01 8.556c0 1.58 1.185 2.745 2.766 2.745.876 0 1.517-.16 1.87-.353v-2.168c-.343.139-2.03.63-2.03-.95v-3.792h2.03v-2.275h-2.03l.01-2.318zm-7.22 5.03c0-.416.341-.576.907-.576.812 0 1.837.246 2.649.683v-2.51a7.043 7.043 0 00-2.649-.49c-2.168 0-3.61 1.131-3.61 3.022 0 2.948 4.059 2.478 4.059 3.749 0 .491-.427.651-1.026.651-.886 0-2.018-.363-2.916-.854v2.542a7.405 7.405 0 002.916.609c2.222 0 3.75-1.1 3.75-3.012-.011-3.183-4.08-2.617-4.08-3.813z"
        fill="#fff"
      />
    </svg>
  )
}
